import { Box, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Typography, Alert, TextField } from '@mui/material'
import { CicaafAPI } from 'api/cicaaf/cicaaf.api'
import DocumentAPI from 'api/document/document'
import { ValidationError } from 'yup';
import { Header } from 'components/home'
import { ContainerForm } from 'components/shared/container_form'
import { TopNavBar } from 'components/top_nav_bar'
import { MenuProvider } from 'contexts/menu/menu_context'
import InputComLabelFormik from 'components/shared/custom_input_label_formik'
import { useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import BottomActionButtons from 'components/shared/bottom_action_buttons'
import { normalizeFileName } from 'utils/normalizeFileName'
import { ROUTES } from 'routes/constants'
import { cpfValidation } from 'utils/yup_cpf_validation'

const validationSchema = Yup.object().shape({
  coordinate_capture_method: Yup.string().required('Método de captura é obrigatório'),
  coordinate_format: Yup.string().required('Formato de coordenada é obrigatório'),
  latitude: Yup.number()
    .typeError('Latitude deve ser um número válido')
    .required('Latitude é obrigatória')
    .min(-90, 'Latitude deve estar entre -90 e 90')
    .max(90, 'Latitude deve estar entre -90 e 90'),
  longitude: Yup.number()
    .typeError('Longitude deve ser um número válido')
    .required('Longitude é obrigatória')
    .min(-180, 'Longitude deve estar entre -180 e 180')
    .max(180, 'Longitude deve estar entre -180 e 180'),
  informant_name: Yup.string()
    .required('Nome é obrigatório')
    .matches(/^[a-zA-ZÀ-ÿ\s\-']+$/, 'O campo Nome deve conter apenas letras.'),
  informant_document: cpfValidation('CPF é obrigatório'),
  informant_phone: Yup.string()
    .required('Telefone é obrigatório')
    .matches(/^\(\d{2}\) \d{5}-\d{4}$/, 'Telefone inválido. Formato esperado: (XX) XXXXX-XXXX'),
  informant_email: Yup.string()
    .required('Email é obrigatório')
    .email('Email inválido'),
  president_name: Yup.string()
    .required('Titular da Entidade é obrigatório')
    .matches(/^[a-zA-ZÀ-ÿ\s\-']+$/, 'O campo Nome deve conter apenas letras.'),
  entity_address: Yup.string().required('Endereço é obrigatório'),
  signature_base64: Yup.string()
    .required('Assinatura é obrigatória')
    .test('isValidSignature', 'Assinatura inválida. A imagem está em branco ou inválida.', (value) => {
      if (!value || value.trim() === '') {
        return false;
      }
      const minSize = 5400;

      if (value.length < minSize) {
        return false;
      }

      const isValidPNG = value.startsWith('data:image/png;base64,');
      return isValidPNG;
    }),



});






export interface IFinalizeCollectionDto {
  coordinate_capture_method: CoordinateCaptureMethodEnum;
  coordinate_format: CoordinateFormatEnum;
  latitude_decimal?: number;
  longitude_decimal?: number;
  latitude_dms?: string;
  longitude_dms?: string;
  informant_name: string;
  informant_document: string;
  informant_phone: string;
  informant_email: string;
  president_name: string;
  president_responsible_name: string;
  informant_signature_uuid: string;
  entity_address: string;
}

export enum CoordinateFormatEnum {
  DECIMAL = 'DECIMAL',
  DMS = 'DMS'
}

export enum CoordinateCaptureMethodEnum {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

const initialValues = {
  coordinate_capture_method: CoordinateCaptureMethodEnum.MANUAL,
  coordinate_format: CoordinateFormatEnum.DECIMAL,
  latitude: -15.5597,
  longitude: -56.0354,
  latitude_dms: '',
  longitude_dms: '',
  informant_name: '',
  informant_document: '',
  informant_phone: '',
  informant_email: '',
  president_name: '',
  informant_signature_uuid: '',
  signature_base64: '',
  entity_address: ''
}

export const base64ToFile = (base64: string, filename: string): File => {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(\w+\/\w+);/)?.[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const uploadSignatureFile = async (signatureBase64: string, uuidVal: string) => {
  const timestamp = new Date().getTime();
  const originalFileName = `assinatura_${uuidVal}_${timestamp}.png`;
  const normalizedFileName = normalizeFileName(originalFileName);
  const signatureFile = base64ToFile(signatureBase64, normalizedFileName);

  const response = await DocumentAPI.upload({
    documentInfo: {
      type: 'DOCUMENTO DE PARCEIRIA',
    },
    file: signatureFile
  });

  return response.uuid;
};

export const formatPhone = (phone: string) => {
  const cleanedPhone = phone.replace(/\D/g, '');

  if (cleanedPhone.length <= 10) {
    return cleanedPhone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (cleanedPhone.length > 10) {
    return cleanedPhone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  return cleanedPhone;
};

export const getCurrentPositionAsync = (options?: PositionOptions): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(resolve, (err) => reject(err), options);
    } else {
      reject(new Error('Geolocalização não é suportada neste navegador.'));
    }
  });
};

export const finalizeCollectionHelper = async (uuidVal: string, finalData: IFinalizeCollectionDto) => {
  return CicaafAPI.finalizeCollection(uuidVal, finalData);
};

export const fetchCollectionData = async (uuidVal: string) => {
  return CicaafAPI.getDataByID(uuidVal);
};

export const finalizeCollectionFlow = async (
  uuidVal: string,
  values: any,
  uploadSignatureFn: (sigBase64: string) => Promise<string>,
  finalizeFn: (id: string, data: IFinalizeCollectionDto) => Promise<any> = finalizeCollectionHelper
) => {
  const cleanedCpf = values.informant_document.replace(/\D/g, '');

  let signatureDocumentUuid = '';
  if (values.signature_base64) {
    signatureDocumentUuid = await uploadSignatureFn(values.signature_base64);
  }

  const finalData: IFinalizeCollectionDto = {
    coordinate_capture_method: values.coordinate_capture_method,
    coordinate_format: values.coordinate_format,
    latitude_decimal: values.coordinate_format === CoordinateFormatEnum.DECIMAL ? values.latitude : undefined,
    longitude_decimal: values.coordinate_format === CoordinateFormatEnum.DECIMAL ? values.longitude : undefined,
    latitude_dms: values.coordinate_format === CoordinateFormatEnum.DMS ? values.latitude_dms : undefined,
    longitude_dms: values.coordinate_format === CoordinateFormatEnum.DMS ? values.longitude_dms : undefined,
    informant_name: values.informant_name,
    informant_document: cleanedCpf,
    informant_phone: values.informant_phone.replace(/\D/g, ''),
    informant_email: values.informant_email,
    president_name: values.president_name,
    president_responsible_name: values.president_name ?? '',
    informant_signature_uuid: signatureDocumentUuid,
    entity_address: values.entity_address
  };

  return finalizeFn(uuidVal, finalData);
};

export const applyFetchedData = (formik: any, data: any) => {
  const dados = data?.dados;
  if (!dados) return;

  if (dados.informant_name) formik.setFieldValue('informant_name', dados.informant_name);
  if (dados.informant_document) formik.setFieldValue('informant_document', dados.informant_document);
  if (dados.informant_phone) formik.setFieldValue('informant_phone', dados.informant_phone);
  if (dados.informant_email) formik.setFieldValue('informant_email', dados.informant_email);
  if (dados.latitude) formik.setFieldValue('latitude', dados.latitude);
  if (dados.longitude) formik.setFieldValue('longitude', dados.longitude);
  if (dados.president_name) formik.setFieldValue('president_name', dados.president_name);
  if (dados.entity_address) formik.setFieldValue('entity_address', dados.entity_address);
  if (dados.informant_signature_uuid) formik.setFieldValue('informant_signature_uuid', dados.informant_signature_uuid);
};

export const validateFormAndRequireSignature = async (formik: any): Promise<string[]> => {
  await formik.validateForm(formik.values);

  if (!formik.isValid || !String(formik.values.signature_base64 || '').trim()) {
    formik.setTouched({
      coordinate_capture_method: true,
      coordinate_format: true,
      latitude: true,
      longitude: true,
      informant_name: true,
      informant_document: true,
      informant_phone: true,
      informant_email: true,
      president_name: true,
      signature_base64: true,
      entity_address: true
    });

    await formik.validateForm(formik.values);
    return ['A assinatura é obrigatória!'];
  }

  return [];
};

export const buildInformarDificuldadesHandlers = (params: {
  uuid?: string | undefined,
  navigate: (path: string) => void,
  formik: any,
  setValidationErrors: (vals: string[]) => void,
  setConfirmDialog: (v: boolean) => void,
  setUploadingSignature: (v: boolean) => void,
  setIsSubmitting: (v: boolean) => void
}) => {
  const { uuid, navigate, formik, setValidationErrors, setConfirmDialog, setUploadingSignature, setIsSubmitting } = params;

  const uploadSignature = async (signatureBase64: string): Promise<string> => {
    try {
      setUploadingSignature(true);
      const uuidGenerated = await uploadSignatureFile(signatureBase64, uuid as string);
      return uuidGenerated;
    } catch (error) {
      console.error('Erro ao fazer upload da assinatura:', error);
      setUploadingSignature(false);
      setIsSubmitting(false);
      throw new Error('Falha no upload da assinatura: ' + (error as Error).message);
    } finally {
      setUploadingSignature(false);
    }
  };

  const handleConfirmSubmit = async () => {
    try {
      setIsSubmitting(true);
      await finalizeCollectionFlow(uuid as string, formik.values, uploadSignature);
      alert('Coleta finalizada com sucesso!');
      setConfirmDialog(false);
      navigate(ROUTES.CICAAF);
    } catch (error) {
      console.error('Erro ao finalizar coleta:', error);
      alert('Erro ao finalizar coleta: ' + (error as Error).message);
    } finally {
      setIsSubmitting(false);
      setUploadingSignature(false);
    }
  };

  const handleCancelSubmit = () => {
    setConfirmDialog(false);
    setIsSubmitting(false);
    setUploadingSignature(false);
    setValidationErrors([]);
  };

  const handleGetDataByID = async () => {
    try {
      const data = await fetchCollectionData(uuid as string);
      const { dados } = data as any;
      return dados;
    } catch (error) {
      console.error('Erro ao buscar dados da coleta:', error);
    }
  };

  const getLocation = () => {
    const options: PositionOptions = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    };

    getCurrentPositionAsync(options)
      .then((position) => {
        formik.setFieldValue('latitude', position.coords.latitude);
        formik.setFieldValue('longitude', position.coords.longitude);
      })
      .catch((err) => {
        console.error('Erro ao obter geolocalização:', err);
        alert('Não conseguimos obter sua localização. Tente novamente.');
      });
  };

  return {
    uploadSignature,
    handleConfirmSubmit,
    handleCancelSubmit,
    handleGetDataByID,
    getLocation
  };
}


export const SignatureCanvas: React.FC<{
  onSignatureChange: (signature: string) => void,
  error?: boolean
}> = ({ onSignatureChange, error }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const startDrawing = (e: React.MouseEvent) => {
    if (isConfirmed) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setIsDrawing(true);

    ctx.beginPath();
    ctx.moveTo(x, y);
  }

  const draw = (e: React.MouseEvent) => {
    if (!isDrawing || isConfirmed) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;


    ctx.lineTo(x, y);
    ctx.stroke();
  }

  const stopDrawing = () => {
    if (isConfirmed) return;
    setIsDrawing(false);
    const canvas = canvasRef.current;
    if (canvas) {
      const signature = canvas.toDataURL();
      onSignatureChange(signature);
    }
  }

  const clearCanvas = () => {
    if (isConfirmed) return;
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    onSignatureChange('');
  }

  const confirmSignature = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const signature = canvas.toDataURL();
      onSignatureChange(signature);
      setIsConfirmed(true);
    }
  }

  const revertSignature = () => {
    setIsConfirmed(false);
    clearCanvas();
  }

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    canvas.width = 800;
    canvas.height = 200;

    ctx.strokeStyle = '#000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
  }, []);

  return (
    <Box width="100%" display="flex" flexDirection="column" alignItems="center">
      <canvas
        ref={canvasRef}
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={stopDrawing}
        onMouseLeave={stopDrawing}
        style={{
          border: error ? '2px solid #d32f2f' : isConfirmed ? '2px solid #4caf50' : '2px solid #ccc',
          borderRadius: '4px',
          cursor: isConfirmed ? 'not-allowed' : 'crosshair',
          width: '800px',
          height: '200px',
          opacity: isConfirmed ? 0.8 : 1
        }}
      />
      <Box display="flex" gap={2} mt={1} justifyContent="center">
        <Button
          onClick={clearCanvas}
          size="small"
          variant="outlined"
          disabled={isConfirmed}
        >
          Limpar Assinatura
        </Button>
        <Button
          onClick={confirmSignature}
          size="small"
          variant="contained"
          color="success"
          disabled={isConfirmed}
        >
          Confirmar Assinatura
        </Button>
        {isConfirmed && (
          <Button
            onClick={revertSignature}
            size="small"
            variant="outlined"
            color="warning"
          >
            Reverter Assinatura
          </Button>
        )}
      </Box>
      {isConfirmed && (
        <Typography variant="caption" color="success.main" mt={1} display="block" textAlign="center">
          ✓ Assinatura confirmada
        </Typography>
      )}
    </Box>
  );
}

export const InformarDificuldadesCicaaf: React.FC = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [uploadingSignature, setUploadingSignature] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      try {
        setValidationErrors([]);
        const errors = await validateFormAndRequireSignature(formik);
        if (errors.length) {
          setValidationErrors(errors);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        setConfirmDialog(true);
      } catch (error) {
        console.error('Erro na validação:', error);
        setValidationErrors(['Erro ao validar os dados. Tente novamente.']);
      }
    }

  });





  // build handlers via exported factory to keep logic testable
  const { uploadSignature, handleConfirmSubmit, handleCancelSubmit, handleGetDataByID, getLocation } = buildInformarDificuldadesHandlers({
    uuid,
    navigate,
    formik,
    setValidationErrors,
    setConfirmDialog,
    setUploadingSignature,
    setIsSubmitting
  });




  // use handlers from factory


  useEffect(() => {
    if (uuid) {
      handleGetDataByID();
    }
  }, [uuid]);






  return (
    <MenuProvider>
      <TopNavBar />
      <Header title={`CICAAF - Encerramento da Coleta`} showBackButton={true} />
      <Box width='97%' display='flex' flexDirection='column' alignItems='center' margin='2rem'>

        {/* Alert para erros de validação */}
        {validationErrors.length > 0 && (
          <Alert
            severity="error"
            sx={{ mb: 3, width: '1152px', maxWidth: '100%' }}
            onClose={() => setValidationErrors([])}
          >
            <Typography variant="h6" gutterBottom>
              Por favor, corrija os seguintes erros:
            </Typography>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              {validationErrors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </Alert>
        )}

        <ContainerForm
          title='1. Coordenadas Geográficas da Unidade'
          subtitle='Informe as coordenadas geográficas da localização da unidade.'
          width='1152px'
        >
          <Box display="flex" flexDirection="column" gap={3}>
            <FormControl>
              <FormLabel component="legend">
                <Typography variant="subtitle1" fontWeight="bold">
                  Método de captura das coordenadas *
                </Typography>
              </FormLabel>
              <RadioGroup
                value={formik.values.coordinate_capture_method}
                onChange={(e) => {
                  formik.setFieldValue('coordinate_capture_method', e.target.value);
                  if (e.target.value === CoordinateCaptureMethodEnum.AUTOMATIC) {
                    getLocation();
                  }
                }}
              >
                <FormControlLabel
                  value={CoordinateCaptureMethodEnum.AUTOMATIC}
                  control={<Radio />}
                  label="Captura automática por GPS"
                />
                <FormControlLabel
                  value={CoordinateCaptureMethodEnum.MANUAL}
                  control={<Radio />}
                  label="Inserção manual (obrigatório no Web)"
                />
              </RadioGroup>
            </FormControl>

            <Box display="flex" gap={2}>
              <InputComLabelFormik
                formik={formik}
                label="latitude"
                labelTexto="Latitude (formato decimal)"
                placeholder="Ex: -15.618889"
                width="48%"
                required
                type="text"
                mask="custom"
                customMask={(v: string) => {
                  if (!v) return '';
                  let s = v.replace(/[^0-9\-.,]/g, '');
                  if (s.startsWith('-')) {
                    s = '-' + s.slice(1).replace(/-/g, '');
                  } else {
                    s = s.replace(/-/g, '');
                  }
                  s = s.replace(/[.,](?=.*[.,])/g, '');
                  return s;
                }}
                onBlur={(e) => {
                  const raw = e.target.value as string;
                  const normalized = raw.replace(',', '.').trim();
                  if (normalized === '' || normalized === '-' || normalized === '-.' || normalized === '.') {
                    return;
                  }
                  const num = Number(normalized);
                  if (!Number.isNaN(num)) {
                    formik.setFieldValue('latitude', num);
                  }
                }}
              />
              <InputComLabelFormik
                formik={formik}
                label="longitude"
                labelTexto="Longitude (formato decimal)"
                placeholder="Ex: -56.097778"
                width="48%"
                required
                type="text"
                mask="custom"
                customMask={(v: string) => {
                  if (!v) return '';
                  let s = v.replace(/[^0-9\-.,]/g, '');
                  if (s.startsWith('-')) {
                    s = '-' + s.slice(1).replace(/-/g, '');
                  } else {
                    s = s.replace(/-/g, '');
                  }
                  s = s.replace(/[.,](?=.*[.,])/g, '');
                  return s;
                }}
                onBlur={(e) => {
                  const raw = e.target.value as string;
                  const normalized = raw.replace(',', '.').trim();
                  if (normalized === '' || normalized === '-' || normalized === '-.' || normalized === '.') {
                    return;
                  }
                  const num = Number(normalized);
                  if (!Number.isNaN(num)) {
                    formik.setFieldValue('longitude', num);
                  }
                }}
              />
            </Box>

            <Alert severity="info">
              <Typography variant="body2">
                <strong>Formato aceito:</strong><br />
                • Decimal: -15.618889 / -56.097778<br />
              </Typography>
            </Alert>
          </Box>
        </ContainerForm>

        {/* Bloco 2: Assinatura do Informante */}
        <ContainerForm
          title='2. Dados do Informante'
          subtitle='Dados do informante responsável pelas informações fornecidas.'
          width='1152px'
        >
          <Box display="flex" flexDirection="column" gap={3}>

            <InputComLabelFormik
              formik={formik}
              label="informant_name"
              labelTexto="Nome *"
              placeholder="Ex: João da Silva"
              width="100%"
            />

            <InputComLabelFormik
              formik={formik}
              label="informant_document"
              labelTexto="CPF *"
              placeholder="Ex: 123.456.789-00"
              width="100%"
              mask={'cpf'}
              maxLength={14}
            />


            <InputComLabelFormik
              formik={{
                ...formik,
                setFieldValue: (field: string, value: string) => {
                  if (field === "informant_phone") {
                    value = formatPhone(value);
                  }
                  formik.setFieldValue(field, value);
                }
              }}
              label="informant_phone"
              labelTexto="Telefone *"
              placeholder="Ex: (11) 99999-9999"
              width="100%"
              mask="telefone"
              maxLength={15}
            />

            <InputComLabelFormik
              formik={formik}
              label="informant_email"
              labelTexto="Email *"
              placeholder="Ex: informante@email.com"
              width="100%"
            />

            <InputComLabelFormik
              formik={formik}
              label="president_name"
              labelTexto="Titular da Entidade "
              placeholder="Ex: Maria dos Santos"
              width="100%"
              required
            />

            <InputComLabelFormik
              label='entity_address'
              required
              formik={formik}
              labelTexto='Endereço'
              placeholder='Endereço'
              width="100%"
            />

            <Box>
              <FormLabel component="legend">
                <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                  Assinatura *
                </Typography>
              </FormLabel>
              <Typography variant="body2" color="textSecondary" mb={2}>
                Desenhe sua assinatura no campo abaixo usando o mouse ou touchscreen
              </Typography>
              <SignatureCanvas
                onSignatureChange={(signature) => formik.setFieldValue('signature_base64', signature)}
                error={formik.touched.signature_base64 && Boolean(formik.errors.signature_base64)}
              />
              {formik.touched.signature_base64 && formik.errors.signature_base64 && (
                <Typography color="error" variant="caption" display="block" mt={1}>
                  {formik.errors.signature_base64}
                </Typography>
              )}

            </Box>
          </Box>
        </ContainerForm>

        <ContainerForm
          title='3. Finalizar Coleta'
          subtitle='Confirma que todos os dados estão corretos e deseja finalizar a coleta?'
          width='1152px'
        >
          <BottomActionButtons
            handleEnviarAprovacao={formik.handleSubmit}
            isFormValid={formik.isValid}
            handleCancelar={async () => {
              if (confirmDialog) {
                setConfirmDialog(false);
                return;
              }
              if (!uuid) {
                navigate(ROUTES.COLETA_CICAAF);
                return;
              }
              try {
                setIsCancelling(true);
                const resp = await CicaafAPI.cancelCollection(uuid);
                if (resp?.Status === 'OK') {
                  navigate(ROUTES.COLETA_CICAAF);
                } else {
                  alert('Erro ao cancelar coleta: ' + (resp?.Mensagem ?? 'Tente novamente.'));
                }
              } catch (err) {
                alert('Erro ao cancelar coleta: ' + (err as Error).message);
              } finally {
                setIsCancelling(false);
              }
            }}
            cancelarTexto={isCancelling ? 'Cancelando...' : 'Cancelar'}
            cancelarDisabled={isCancelling}
          />

        </ContainerForm>




        {/* Dialog de Confirmação */}
        {confirmDialog && (
          <Box
            position="fixed"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgcolor="rgba(0,0,0,0.5)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex={9999}
          >
            <Box
              bgcolor="white"
              p={4}
              borderRadius={2}
              maxWidth="400px"
              textAlign="center"
            >
              <Typography variant="h6" mb={2}>
                Confirmação
              </Typography>
              <Typography variant="body1" mb={3}>
                Confirma que todos os dados estão corretos e deseja finalizar a coleta?
              </Typography>
              {uploadingSignature && (
                <Typography variant="body2" color="primary" mb={2}>
                  📤 Fazendo upload da assinatura...
                </Typography>
              )}
              <Box display="flex" gap={2} justifyContent="center">
                <Button
                  variant="outlined"
                  onClick={handleCancelSubmit}
                  disabled={isSubmitting || uploadingSignature}
                >
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmSubmit}
                  disabled={isSubmitting || uploadingSignature}
                >
                  {uploadingSignature ? 'Salvando assinatura...' :
                    isSubmitting ? 'Finalizando...' : 'Confirmar'}
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </MenuProvider>
  )
}
